// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import axios from "axios";
import router from "./router";
import VueCookies from "vue-cookies";
import store from './store/index.js'
import "vant/lib/index.css";
import vant from "vant";
import aliUpload from '@/utils/commonUpLoad.js'
import 'normalize.css'
import '@/style/iconfont.css'
import {
  Toast
} from 'vant'
import service from './api/request'
import {
  getToken
} from '@/api/assocInfo'
import pdf from "vue-pdf";
Vue.use(pdf);
Vue.use(VueCookies);
Vue.use(vant);
Vue.config.productionTip = false;
const instance = axios.create({
  baseURL: "/rng",
  timeout: 10000
});
Vue.prototype.$axios = instance;
Vue.prototype.$request = service;
Vue.prototype.$aliUpload = aliUpload;
Vue.prototype.$showLoading = (message = '加载中...') => {
  Toast.loading({
    duration: 0,
    forbidClick: true,
    message,
    overlay: true
  })
}

// 获取token
// if (!sessionStorage.getItem('token')) {
//   // const url = window.location.host.toString()  ? window.location.host.split(":")[0]: '135-nuxt.dev.hangxintong.cn'
//   const url = '135-h5.dev.hangxintong.cn'
//   getToken({
//     appletsWebUrl: url
//   }).then(res => {
//     if (res.code === 200) {
//       sessionStorage.setItem('token', res.data.assocToken)
 
//     }else{
//       Toast(res.message);
 
//     }
//   }).catch((err) => {
 
//     Toast(err.message);
//   })
// }


/* eslint-disable no-new */
// if(sessionStorage.getItem('token')){
// new Vue({
//   el: "#app",
//   router,
//   store,
//   components: {
//     App
//   },
//   template: "<App/>"
// });
// }

new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});


// WEBPACK FOOTER //
// ./src/main.js